import Lembrar from 'core/views/Lembrar.vue'
import Alterar from 'core/views/Alterar.vue'
import Ativar from 'core/views/Ativar.vue'
import Logout from '../views/Logout.vue'

export default [
  {
    title: 'Início ',
    icon: 'fas fa-home',
    path: '/home',
    menu: true,
    home: true,
    dir: 'views/',
    view: 'Home',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    path: '/carregando',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Carregando',
  },
  {
    path: '/erro',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Erro',
  },
  {
    path: '/sessao-expirada',
    title: 'Sessão expirada',
    menu: false,
    dir: 'views/',
    view: 'SessaoExpirada',
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/erro-limite',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'ErroLimite',
  },
  {
    title: 'Propostas',
    path: '/propostas',
    menu: true,
    dir: 'views/',
    view: 'PropostaList',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    path: '/logout',
    view: 'Logout',
    menu: false,
    dir: 'views/',
    meta: {
      anonymousAuth: true
    }
  },
  {
    title: 'Lista Limite',
    path: '/limite',
    menu: false,
    dir: 'views/',
    view: 'ListLimite',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Simular Proposta',
    path: '/contratacao',
    menu: false,
    dir: 'views/',
    view: 'PropostaAdd',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Detalhes do Contrato',
    path: '/detalhes',
    menu: false,
    dir: 'views/',
    view: 'Detalhes',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    path: '/lembrar',
    component: Lembrar,
    default: true,
    title: 'Lembrar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    component: Alterar,
    default: true,
    title: 'Alterar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/ativar',
    component: Ativar,
    default: true,
    title: 'Ativar conta',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/authToken/',
    dir: 'views/',
    view: 'LoginToken',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/authPartnerToken/:token',
    dir: 'views/',
    view: 'LoginPartnerToken',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/partner/:parceiro',
    title: 'Plataforma Indisponível',
    menu: false,
    dir: 'views/',
    view: 'PlataformaIndisponivel',
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/',
    title: 'Logout',
    menu: false,
    component: Logout,
    meta: {
      anonymousAuth: true
    }
  }
]
